/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/packs/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 55);
/******/ })
/************************************************************************/
/******/ ({

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player__ = __webpack_require__(56);


/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player__ = __webpack_require__(57);


function loadPlayer() {
  var player = new __WEBPACK_IMPORTED_MODULE_0__player__["a" /* default */](window.PLAYER_METADATA);
  var photo = player.get('twitter_photo');
  if (photo) {
    var imageUrl = photo.replace(/_normal\.jp/, '_200x200.jp');
    var downloadingImage = new Image();
    var profileImage = document.querySelector('.js-player-twitter-photo');

    downloadingImage.onload = function (e) {
      profileImage.src = imageUrl;
      profileImage.alt = player.name + '\'s twitter avatar';
    };

    downloadingImage.onerror = function (e) {
      profileImage.src = profileImage.dataset.fallbackImage;
    };

    downloadingImage.src = imageUrl;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadPlayer);
} else {
  loadPlayer();
}

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Player() {
  var _this = this;

  var playerData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  this.attributes = playerData;

  this.get = function (attribute) {
    return _this.attributes[attribute];
  };

  this.set = function (attribute, value) {
    _this.attributes[attribute] = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Player);

/***/ })

/******/ });


// WEBPACK FOOTER //
// player-30fc5ffa7ea8b6b69481.js